import { random } from 'lodash'

const randomDelay = ({ callback, maxSeconds }) => {
  const delayMillis = random(maxSeconds * 1000)
  console.log(`delaying ${delayMillis} millis`)
  setTimeout(callback, delayMillis)
}

const isPast = (dateString) => {
  const date = new Date(dateString)
  let now = new Date()
  let distance = date.getTime() - now.getTime()
  return distance <= 0
}

export { randomDelay, isPast }
